import { Component, OnInit,ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FnModalService, FnToasterService, FnUtilService} from 'foundation';
import { JpqlService } from './jpql.service';
import { PosUtilService } from '../../services/pos-util.service';
import { JpqlParseComponent } from './jpql-parse/jpql-parse.component';
import { JpqlBulkQueriesComponent } from './jpql-bulk-queries/jpql-bulk-queries.component';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';


@Component({
  selector: 'app-jpql',
  templateUrl: './jpql.component.html',
  styleUrls: ['./jpql.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class JpqlComponent implements OnInit {
  isLoading = false;
  // options:SimpleBarOptions = { autoHide: false, scrollbarMinSize: 40 };
  isJSONData = false;
  isLoggedIn = false;
  isNative=false;
  queryString = '';
  jpqlJSONResult = '';
  jpqlResult!: JPQLResult;

  params = {
    isLoadingQuery: false
  }

  paginationMap = {
		currentPage: 1,
		totalSize: 1,
		pageSize: 10,
	};

  // totalRecordsFetched = 0;
  columnArray: string[] = [];

  constructor(
    private jpqlService: JpqlService,
    private toaster: FnToasterService,
    private dialogSvcs: FnModalService,
    public posUtil: PosUtilService,
    private fnModalSvcs: FnModalService
  ) { }

  ngOnInit(): void {
    this.init();
    if (localStorage.getItem('isLoggedIn') == "yes") {
      this.isLoggedIn = true
    }
    else {
      this.isLoggedIn = false;
    }
  }

  init() {
    this.jpqlResult = {
      isSuccess: false,
      entityArray: [],
      updatedRows: -1,
      queryType: 'select',
      message: '',
      rawQuery: '',
      recordSize: 0,
      cssClass: 'green'
    };
  }

  executeQuery(queryString: string) {
    queryString = queryString.trim();
    this.init();
    if (this.posUtil.emptyString(queryString)) {
      this.toaster.error("Please type query ⚠️");
      return;
    }

    this.jpqlResult.queryType = queryString.split(" ")[0].toLowerCase();
    if (!this.isValidQuery()) {
      this.toaster.error("Please type a valid query ⚠️");
      return;
    }

    this.jpqlResult.rawQuery = queryString;

    if(!this.isNative){
    if (this.jpqlResult.queryType == 'update' || this.jpqlResult.queryType == 'delete') {
      this.jpqlService.getQueryResultCount(queryString).subscribe((resp: any) => {
        if (resp.isError) {
          this.jpqlResult.cssClass = 'red';
          this.showJpqlMsg(resp.message, false);
          return;
        }
        this.jpqlResult.updatedRows = resp;
        const dialogRef = this.dialogSvcs.openConfirmModal({
          isConformationMdl: true,
          content:
            `${this.jpqlResult.updatedRows} row(s) will be ${this.jpqlResult.queryType}d.`,
          type: 'danger',
        });
        dialogRef.afterClosed().subscribe((doAction) => {
          if (doAction) {
            if (this.jpqlResult.updatedRows > 0)
              this.sendQuerytoService(queryString);
            else {
              this.jpqlResult.cssClass = 'green';
              this.showJpqlMsg("No Record Found", true);
            }
          }
        });
      }
        // , err => {
        //   this.jpqlResult.cssClass = 'red';
        //   this.showJpqlMsg(err.error.message, false);
        // }
      )
    }
    else {
      this.sendQuerytoService(queryString);
    }
  }else if(this.isNative){
    if (this.jpqlResult.queryType == 'update' || this.jpqlResult.queryType == 'delete' || this.jpqlResult.queryType == 'alter' ||this.jpqlResult.queryType=='drop') {
      this.jpqlService.getQueryResultCountNative(queryString).subscribe((resp: any) => {
        if (resp.isError) {
          this.jpqlResult.cssClass = 'red';
          this.showJpqlMsg(resp.message, false);
          return;
        }
        this.jpqlResult.updatedRows = resp;
        const dialogRef = this.dialogSvcs.openConfirmModal({
          isConformationMdl: true,
          content:
            `${this.jpqlResult.updatedRows} row(s) will be ${this.jpqlResult.queryType}d.`,
          type: 'danger',
        });
        dialogRef.afterClosed().subscribe((doAction) => {
          if (doAction) {
            // if (this.jpqlResult.updatedRows > 0)
            //   this.sendQuerytoServiceNative(queryString);
            // else {
            //   this.jpqlResult.cssClass = 'green';
            //   this.showJpqlMsg("No Record Found", true);
            // }
            if(this.jpqlResult.updatedRows>0){
              this.jpqlResult.recordSize=this.jpqlResult.updatedRows
              this.jpqlResult.cssClass = 'green';
              this.showJpqlMsg(`${this.jpqlResult.updatedRows} Rows are ${this.jpqlResult.queryType}d`, true)
            }else{
              this.jpqlResult.cssClass = 'red';
              this.showJpqlMsg("No Record Found", true);
            }
          }
        });
      }
        // , err => {
        //   this.jpqlResult.cssClass = 'red';
        //   this.showJpqlMsg(err.error.message, false);
        // }
      )
    }
    else {
      this.sendQuerytoServiceNative(queryString);
    } 
  }

  }

  sendQuerytoService(queryString: string,) {
    this.params.isLoadingQuery = true;
    this.jpqlService.getQueryFromUser(queryString).subscribe(resp => {
      if (resp.isError) {
        this.jpqlResult.cssClass = 'red';
        this.showJpqlMsg(resp.message, false);
        return;
      }
      this.jpqlResult.isSuccess = true;
      // this.jpqlResult.cssClass = 'green';
      if (this.jpqlResult.queryType == 'select') {
        if (resp.length > 0) {
          this.jpqlResult.updatedRows = resp.length;
          this.jpqlResult.entityArray = resp;
          this.jpqlJSONResult = JSON.stringify(resp, null, 2);;
          for (const obj of this.jpqlResult.entityArray) {
            this.columnArray = Object.keys(obj)
            
          }
        }
        // this.totalRecordsFetched = resp.length;
        this.jpqlResult.recordSize = resp.length;
      }
      else {
        // this.jpqlResult.cssClass = 'green';
        if (this.jpqlResult.updatedRows > 1)
          this.showJpqlMsg(`${this.jpqlResult.updatedRows} Rows are ${this.jpqlResult.queryType}d`, true)
        else
          this.showJpqlMsg(`${this.jpqlResult.updatedRows} Row is ${this.jpqlResult.queryType}d`, true)
      }


      if (this.jpqlResult.queryType == 'update' || this.jpqlResult.queryType == 'delete')
        this.toaster.success("Rows are " + this.jpqlResult.queryType + "d Succesfully");

      this.params.isLoadingQuery = false;
    }
      // ,
      //   err => {
      //     this.jpqlResult.cssClass = 'red';
      //     this.showJpqlMsg(err.error.message, false);
      //   }
    );
  }


  sendQuerytoServiceNative(queryString: string,) {
    this.params.isLoadingQuery = true;
    this.jpqlService.getQueryFromUserNative(queryString).subscribe(resp => {
      if (resp.isError) {
        this.jpqlResult.cssClass = 'red';
        this.showJpqlMsg(resp.message, false);
        return;
      }
      this.jpqlResult.isSuccess = true;
      // this.jpqlResult.cssClass = 'green';
      if (this.jpqlResult.queryType == 'select') {
        if (resp.length > 0) {
          this.jpqlResult.updatedRows = resp.length;
          this.jpqlResult.entityArray = resp;
          this.jpqlJSONResult = JSON.stringify(resp, null, 2);;
          for (const obj of this.jpqlResult.entityArray) {
            this.columnArray = Object.keys(obj)
            
          }
        }
        // this.totalRecordsFetched = resp.length;
        this.jpqlResult.recordSize = resp.length;
        this.calcPageSize(this.jpqlResult.recordSize);
      }
      else {
        // this.jpqlResult.cssClass = 'green';
        if (this.jpqlResult.updatedRows > 1)
          this.showJpqlMsg(`${this.jpqlResult.updatedRows} Rows are ${this.jpqlResult.queryType}d`, true)
        else
          this.showJpqlMsg(`${this.jpqlResult.updatedRows} Row is ${this.jpqlResult.queryType}d`, true)
      }


      if (this.jpqlResult.queryType == 'update' || this.jpqlResult.queryType == 'delete')
        this.toaster.success("Rows are " + this.jpqlResult.queryType + "d Succesfully");

      this.params.isLoadingQuery = false;
    }
      // ,
      //   err => {
      //     this.jpqlResult.cssClass = 'red';
      //     this.showJpqlMsg(err.error.message, false);
      //   }
    );
  }

  clearCache() {
    this.jpqlService.clearCache().subscribe(resp =>
    {

      if (resp != null) {
        this.toaster.success(resp.data);
        return;
      }
      else{
          this.toaster.error('Failed to clear cache');
          return;
      }
    })
  }

  

  showJpqlMsg(message: string, flag: boolean) {
    this.params.isLoadingQuery = false;
    // this.params.isResponse = false;
    this.jpqlResult.message = message;
    this.jpqlResult.isSuccess = flag;
  }

  isValidQuery(): boolean {
    if (
      this.jpqlResult.queryType === 'select' ||
      this.jpqlResult.queryType === 'update' ||
      this.jpqlResult.queryType === 'delete' ||
      this.jpqlResult.queryType === 'alter'  ||
      this.jpqlResult.queryType === 'drop'
    ) {
      return true;
    }
    return false;
  }


  openModal(content: string): void {
    if (content == 'parse') {
      this.fnModalSvcs.openCustomModal(JpqlParseComponent, {
        data: { },
        width: '500px'
      })
    }
    if (content == 'bulkQueries') {
      this.fnModalSvcs.openCustomModal(JpqlBulkQueriesComponent, {
        data: { },
        width: '500px'
      })
    }
    // this.fnModalSvcs.openCustomModal(JpqlLargeDataComponent, {
    //   data: {content},
    //   width:'500px'
    // })
  }

  downloadExcel(queryString: string) {
    queryString = queryString.trim();
    this.init();
    if (this.posUtil.emptyString(queryString)) {
      this.toaster.error("Please type query ⚠️");
      return;
    }

    this.jpqlResult.queryType = queryString.split(" ")[0].toLowerCase();
    if (!this.isValidQuery()) {
      this.toaster.error("Please type a valid query ⚠️");
      return;
    }
    if(!this.isNative){
      this.jpqlService.getQueryFromUser(queryString).subscribe(resp => {
        if(resp.isError){
          // this.toaster.error(resp.message);
          this.jpqlResult.cssClass = 'red';
        this.showJpqlMsg(resp.message, false);
         throw new Error();
        }
      //  this.jpqlResult.isSuccess = true;
        this.jpqlResult.entityArray=resp;
        this.jpqlJSONResult = JSON.stringify(resp, null, 2);;
        for (const obj of this.jpqlResult.entityArray) {
          this.columnArray = Object.keys(obj)
          
        }
       // Check if there is data to download
       if (!this.jpqlResult.entityArray || this.jpqlResult.entityArray.length === 0) {
        this.toaster.error('No data available to download ⚠️');
        throw new Error();
      }

    // Prepare the data to be written to Excel
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.jpqlResult.entityArray);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
  
    // Generate Excel file
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  
    // Create a Blob from the Excel buffer
    const blob: Blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  
    // Save the Excel file
    saveAs(blob, 'JPQL_Result.xlsx');
      })
    }
    else if(this.isNative){ 
      this.jpqlService.getQueryFromUserNative(queryString).subscribe(resp => {
        if(resp.isError){
        //  this.toaster.error(resp.message);
          this.jpqlResult.cssClass = 'red';
        this.showJpqlMsg(resp.message, false);
          throw new Error();
        }
        //this.jpqlResult.isSuccess = true;
        this.jpqlResult.entityArray=resp;
        this.jpqlJSONResult = JSON.stringify(resp, null, 2);;
        for (const obj of this.jpqlResult.entityArray) {
          this.columnArray = Object.keys(obj)
          
        }
       // Check if there is data to download
       if (!this.jpqlResult.entityArray || this.jpqlResult.entityArray.length === 0) {
        this.toaster.error('No data available to download ⚠️');
        throw new Error();
      }

    // Prepare the data to be written to Excel
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.jpqlResult.entityArray);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
  
    // Generate Excel file
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  
    // Create a Blob from the Excel buffer
    const blob: Blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  
    // Save the Excel file
    saveAs(blob, 'JPQL_Result.xlsx');
      })
    }
    
  
  }

  public paginzationEvent(eventObj: any) {
		this.paginationMap.currentPage = eventObj;

	}
  public calcPageSize(dataArray: any) {
		this.paginationMap.totalSize = Math.ceil(
			dataArray / this.paginationMap.pageSize
		);
    // this.paginationMap.totalSize = Math.ceil(
    //   dataArray.length / this.paginationMap.pageSize
    // );
	}



}

interface JPQLResult {
  isSuccess: boolean;
  entityArray: any[];
  updatedRows: number;
  queryType: string;
  message: string;
  rawQuery: string;
  recordSize: number;
  cssClass: string;
} 
